<template>
  <div class="head-content">
    <div>
      <img :src="plat_logo" alt="" @click="jumpto(website)" style="cursor: pointer;max-height: 46px;">
    </div>
    <div class="head-content-right">
      <div class="head-content-right-user">
        <div class="right-user-img">
          <img :src="userlogo" alt="" v-if="userlogo">
          <img src="../assets/img/user-icon.png" alt="" v-else>
        </div>
        <span class="user-name">{{ username }}</span>
        <div class="user-info-content">
          <div class="user-info-content-top">
            <div class="right-user-img">
              <img :src="userlogo" alt="" class="user-info-content-top-photo" v-if="userlogo">
              <img src="../assets/img/user-icon.png" alt="" class="user-info-content-top-photo" v-else>
            </div>
            <span class="company-name">{{ company }}</span>
          </div>
          <div class="user-info-content-bottom">
            <div class="user-info-bottom-item" @click="userInfoHandle">
              <img src="../assets/img/user-info.png" alt="">
              <span class="user-info-bottom-item-text">个人信息</span>
            </div>
            <div class="user-info-bottom-item" @click="exit">
              <img src="../assets/img/logo-out.png" alt="">
              <span class="user-info-bottom-item-text">退出</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import paltform from '../assets/js/paltform.json'
import { getUserinfo, getPlatform } from '../assets/js/common'
export default {
  name: 'headPage',
  data() {
    return {
      platform: 4,
      username: '',
      company: '',
      userlogo: '',
      language: '',
      plat_icon: "",
      plat_logo: "",
      website: "",
    }
  },
  methods: {
    userInfoHandle() {
      this.$router.push({
        name: 'userinfo'
      })
    },
    exit() {
      localStorage.removeItem('ai-token');
      localStorage.removeItem('ai-info');
      location.href = '/login';
    },
    //跳转
    jumpto(url) {
      location.href = this.website;
    },
  },
  beforeCreate() {
    let token = localStorage.getItem('ai-token');
    if (token == null) {
      this.$router.push('login');
    }
    var info = getUserinfo();
    if (info.auth == 'administrator') {
      this.$router.push('admin');
    }
  },
  created() {
    var info = getUserinfo();
    this.platform = info.plat;
    this.username = info.username;
    this.company = info.company ? info.company : '公司未填';
    this.userlogo = info.logo;

    let platjson = getPlatform();
    console.log(platjson)
    this.language = platjson.language;
    this.plat_icon = platjson.icon;
    this.plat_logo = platjson.logo;
    this.website = platjson.website;
    document.getElementById("icon").href = platjson.icon;
  }
}

</script>
<style>
.head-content {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}

.head-content-right {
  height: 100%;
}

.head-content-right-user {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.user-name {
  display: block;
  font-size: 16px;
  color: #061237;
  margin-left: 14px;
}

.user-info-content {
  opacity: 0;
  width: 240px;
  height: 0px;
  position: absolute;
  top: 72px;
  z-index: 9999;
  right: -2px;
  background-color: #fff;
  border-radius: 5px;
  transform: scaleY(0);
  border: 1px solid #ebeef5;
  box-shadow: 4px 6px 16px 0px rgba(194, 194, 194, 0.31);
  transition: all 0.2s linear;
}

.head-content-right-user:hover .user-info-content {
  opacity: 1;
  transform: scaleY(1);
  height: 190px;
}

.user-info-content .company-name {
  font-size: 14px;
  color: #061237;
  margin-left: 10px;
}

.user-info-content-top {
  box-sizing: border-box;
  padding: 20px;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  align-items: center;
}

.user-info-content-top-photo {
  width: 36px;
}

.user-info-content-bottom {
  height: 114px;
  box-sizing: border-box;
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.user-info-bottom-item {
  height: 50%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 14px 20px;
  border-radius: 3px;
  cursor: pointer;
}

.user-info-bottom-item-text {
  font-size: 14px;
  color: #333;
  margin-left: 16px;
}

.user-info-bottom-item:hover {
  background-color: rgba(40, 130, 255, 0.1);

}

.right-user-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.right-user-img img {
  width: 100%;
}
</style>